export type MessageAppearanceAckTimestamps = {
  clientTimestamp: number
  serverTimestamp?: number | null
}

/** Prefer platform server receipt time for delay metrics; fall back to device-reported time. */
export const getAckTimestampForDelay = (ack: MessageAppearanceAckTimestamps): number =>
  ack.serverTimestamp ?? ack.clientTimestamp
